var map = {
	"./daebak-realestate.md": 272,
	"./dummy-mommy.md": 273,
	"./elegant-empire.md": 274,
	"./flames-of-desire.md": 275,
	"./glamorous-temptation.md": 276,
	"./golden-rainbow.md": 277,
	"./good-thieves.md": 278,
	"./great-catsby.md": 279,
	"./im-not-a-robot.md": 280,
	"./kill-heel.md": 281,
	"./may-queen.md": 282,
	"./mermaid-story.md": 283,
	"./miss-montecristo.md": 284,
	"./shine-or-go-crazy.md": 285,
	"./the-chegos-chicken.md": 286,
	"./the-man-called-GOD.md": 287,
	"./when-i-was-the-prettiest.md": 288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 271;